import { render } from "./detailHome.vue?vue&type=template&id=7dfd5735&scoped=true"
import script from "./detailHome.vue?vue&type=script&lang=js"
export * from "./detailHome.vue?vue&type=script&lang=js"

import "./detailHome.vue?vue&type=style&index=0&id=7dfd5735&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfd5735"]])

export default __exports__